import Head from 'next/head';
import * as React from 'react';
import styled from 'styled-components';
import { GetServerSideProps } from 'next';
import { staticTheme } from '@/utils/theme';
import { withSession } from '@zopauk/nextjs-auth';
import { ProductTemplate } from '@/components/ProductTemplate';
import { RepAprCalculator } from '@/components/RepAprCalculator';
import { Heading, Text, Link, grid } from '@zopauk/react-components';
import { handleOriginationsWebRollout } from '@/utils/handleOriginationsWebRollout';
import { type BaseButtonProps, buttonStyleJL } from '@/components/RepAprCalculator/buttonStyleJL';

//TODO: this is hard coded as buttonStyleJL as this page is JL only for now but should be themed?
const ButtonLink = styled(Link)<BaseButtonProps>`
  ${buttonStyleJL}
  width: 100%;
  justify-content: center;

  @media (min-width: ${grid.breakpoints.m}px) {
    width: auto;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: stretch;
`;

const Calculator = () => {
  const [amount, setAmount] = React.useState(10000);
  const [term, setTerm] = React.useState(48);
  const [href, setHref] = React.useState('');

  React.useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();

    newParams.set('term', term.toString());
    newParams.set('amount', amount.toString());

    const queryParams = ['campaign', 'channel', 'tmcampid', 's_emcid', 's_emuid'];
    for (const param of queryParams) {
      const value = currentParams.get(param);
      if (value) {
        newParams.set(param, value);
      }
    }

    // Construct the new URL
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHref(`${staticTheme().basePath}/?${newParams.toString()}`);
  }, [amount, term]);

  return (
    <>
      <Head>
        <title>Get your personalised rates</title>
      </Head>
      <ProductTemplate title={'Get your personalised rates'} currentStep={0}>
        <Text className="mb-6" as="p">
          John Lewis Money is pleased to offer loans provided by Zopa bank.
        </Text>
        <Text className="mb-6" as="p">
          John Lewis Finance Limited is a credit broker introducing personal loans of Zopa Bank - a fully licensed
          regulated UK bank with over 19 years of lending experience. John Lewis Finance Limited is a credit broker, not
          a lender.
        </Text>
        <Text as="p">
          See your personalised loan rates in just 3 minutes so you know exactly what you could get. Our rates are often
          among the lowest out there. Checking your rates won't affect your credit score.
        </Text>
        <RepAprCalculator setAmount={setAmount} setTerm={setTerm} amount={amount} term={term} />
        <Heading className="mt-8 mb-2" as="h4">
          Representative example
        </Heading>
        <Text className="mb-6" as="p">
          A loan of £10,000 over 5 years will cost you £209.91 per month at a representative 9.9% APR. <br />
        </Text>
        <Text className="mb-6" as="p">
          The total cost after 5 years is £12,594.46, which includes £2,594.46 interest at 9.9% fixed and a £0 fee. The
          total amount of credit is £10,000.
          <br />
        </Text>
        <Text className="mb-8" as="p">
          The rate you are offered will depend on your individual circumstances.
        </Text>
        <ButtonContainer>
          <ButtonLink href={href}>Continue</ButtonLink>
        </ButtonContainer>
      </ProductTemplate>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = handleOriginationsWebRollout('/loans/quotation/calculator');

export default withSession(Calculator, {
  forceLogin: false,
});
